module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "opacity-0",
    attrs: {
      "id": "page-footer"
    }
  }, [_c('div', {
    staticClass: "content py-20 font-size-xs clearfix"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_vm._v("\n      Crafted with\n      "), _c('i', {
    staticClass: "fa fa-heart text-pulse"
  }), _vm._v(" by\n      "), _c('a', {
    staticClass: "font-w600",
    attrs: {
      "href": "http://fresh-media.nl",
      "target": "_blank"
    }
  }, [_vm._v("Fresh-Media")])]), _vm._v(" "), _c('div', {
    staticClass: "float-left"
  }, [_c('span', {
    staticClass: "font-w600"
  }, [_vm._v("VMControl")]), _vm._v(" ©\n      "), _c('span', {
    staticClass: "js-year-copy"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b5dc91d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/partials/Footer.vue
// module id = 713
// module chunks = 1